/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { DELETE_ADDRESS_FAILURE, POST_ADDRESS_FAILURE, UPDATE_ADDRESS_FAILURE } from '../store/types/authorizationTypes';
import {
  getAddress,
  postAddress,
  updateAddress,
  deleteAddress,
  getAuthorizationSummaryAddress
} from '../store/actions/authorizations.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React, { useMemo, useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import { useEnumColumns } from 'modules/common/enumTableColumn';
import AddressManagementTable from './addressManagementTable.component';
import { withStyles } from '@material-ui/core';

import { Box, Card, CardContent, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  },
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
});

const AddressManagementCard = props => {
  const { addresses, id, hideEdit, addressTypesEnum, countriesEnum, provincesEnum, destinationAddressId } = props;

  const [isLoading, setIsLoading] = useState(false);
  const { addressTypeColumn, countryColumn, provinceColumn } = useEnumColumns();

  // Filtering out Vendor, Client and Title Company since they're not relevant here
  const addressTypes = useMemo(() => {
    let filteredAddresses = addressTypesEnum && addressTypesEnum.length > 0
      ? addressTypesEnum.filter(
        s =>
          s.isActive === true &&
          s.id !== 'b530b48e-6f25-4356-8d7b-70efb5a8005e' &&
          s.id !== '67a86dee-2aa4-4975-9df0-95368dfec694' &&
          s.id !== 'a9f7b1e1-1335-48f6-b7b3-2d90669a528d'
      )
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    // Disable Departure address type if we already have one in the auth's addresses
    if (addresses.some(x => x.addressTypeId === 'aff1270e-2713-4026-a667-872ae9757825')) {
      filteredAddresses = filteredAddresses.map(x => ({
        ...x,
        disabled: x.id === 'aff1270e-2713-4026-a667-872ae9757825'
      }));
    }

    return filteredAddresses;
  }, [addresses]);

  const countries =
    countriesEnum && countriesEnum.length > 0
      ? countriesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const provinces =
    provincesEnum && provincesEnum.length > 0
      ? provincesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  //TODO - Probably need to filter the states based on country and disabled it at first? Slow load.
  const addressColumns = [
    {
      header: 'Address Type',
      ...addressTypeColumn('addressTypeId'),
      type: 'dropdown-v2',
      options: addressTypes,
      required: true
    },
    { header: 'Street Address', accessorKey: 'addressLine1', type: 'text', required: true },
    { header: 'Apartment/Suite/Floor', accessorKey: 'addressLine2', type: 'text', hideInTable: true, required: false },
    { header: 'Additional Address Info', accessorKey: 'addressLine3', type: 'text', hideInTable: true, required: false },
    { header: 'City', accessorKey: 'city', type: 'text', required: false },
    { header: 'County', accessorKey: 'county', type: 'text', hideInTable: true, required: false },
    { header: 'Zip Code', accessorKey: 'zipcode', type: 'text', hideInTable: true, required: false },
    {
      header: 'Country',
      ...countryColumn('countryId'),
      type: 'dropdown-v2',
      options: countries,
      required: true
    },
    {
      header: 'State',
      ...provinceColumn('provinceId'),
      type: 'dropdown-v2',
      options: provinces,
      required: false
    }
  ];

  const updateAddress = async (address, values) => {
    const addressId = address.original.addressId;

    let newValues = {
      authorizationId: id,
      addressId: addressId,
      addressTypeId: values.addressTypeId ? values.addressTypeId : '',
      addressLine1: values.addressLine1 ? values.addressLine1 : '',
      addressLine2: values.addressLine2 ? values.addressLine2 : '',
      addressLine3: values.addressLine3 ? values.addressLine3 : '',
      city: values.city ? values.city : '',
      county: values.county ? values.county : '',
      zipcode: values.zipcode ? values.zipcode : '',
      countryId: values.countryId ? values.countryId : '',
      provinceId: values.provinceId ? values.provinceId : '',
      addedBy: values.addedBy ? values.addedBy : 1,
      addedOn: values.addedOn ? values.addedOn : new Date(),
      modifiedBy: values.modifiedBy ? values.modifiedBy : 1,
      modifiedOn: new Date()
    };

    const resp = await props.updateAddress(id, newValues);
    if (resp.type === UPDATE_ADDRESS_FAILURE) {
      props.showToast('Failed to update address info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getAuthorizationSummaryAddress(id);
      props.showToast('Address updated successfully.', { userMustDismiss: false, severity: 'success' });
      return true;
    }
  };

  const createAddress = async values => {
    let newValues = {
      authorizationId: id,
      addressTypeId: values.addressTypeId ? values.addressTypeId : '',
      addressLine1: values.addressLine1 ? values.addressLine1 : '',
      addressLine2: values.addressLine2 ? values.addressLine2 : '',
      addressLine3: values.addressLine3 ? values.addressLine3 : '',
      city: values.city ? values.city : '',
      county: values.county ? values.county : '',
      zipcode: values.zipcode ? values.zipcode : '',
      countryId: values.countryId ? values.countryId : '',
      provinceId: values.provinceId ? values.provinceId : '',
      addedBy: values.addedBy ? values.addedBy : 1,
      addedOn: values.addedOn ? values.addedOn : new Date(),
      modifiedBy: values.modifiedBy ? values.modifiedBy : 1,
      modifiedOn: new Date()
    };

    const resp = await props.postAddress(id, newValues);

    if (resp.type === POST_ADDRESS_FAILURE) {
      props.showToast('Failed to create new address, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      await props.getAuthorizationSummaryAddress(id);
      props.showToast('Address created successfully.', { userMustDismiss: false, severity: 'success' });
      return true;
    }
  };

  const deleteAddress = async address => {
    const deleteAddressResp = await props.deleteAddress(id, address.original.addressId);
    if (deleteAddressResp.type === DELETE_ADDRESS_FAILURE) {
      props.showToast(
        'Failed to delete the address because it is used in an auth service or trip. Remove it from there first and try again.',
        { severity: TOAST_MESSAGE_SEVERITY_ERROR }
      );
    } else {
      await props.getAuthorizationSummaryAddress(id);
      props.showToast('Address deleted successfully.', { userMustDismiss: false, severity: 'success' });
    }
  };

  return (
    <>
      {addresses && (
        <>
          <Card sx={{ marginTop: '16px' }}>
            <Box>
              <CardContent className={props.classes.cardContainer}>
                <div className="row justify-space-between align-center">
                  <div className={props.classes.iconRow}>
                    <Tooltip title={'Addresses'} key={'Addresses'} placement="right">
                      <FontAwesomeIcon icon={['fas', 'house']} size="2x" />
                    </Tooltip>
                    <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                      Addresses
                    </Typography>
                  </div>
                </div>
              </CardContent>
              <Box sx={{ padding: '10px', marginLeft: '30px' }}>
                {!isLoading && (
                  <AddressManagementTable
                    classes={props.classes}
                    columns={addressColumns}
                    rows={addresses || []}
                    createRow={createAddress}
                    updateRow={updateAddress}
                    deleteRow={deleteAddress}
                    customAddText={'Add Address'}
                    hideEdit={hideEdit}
                    countriesEnum={countries}
                    provincesEnum={provinces}
                    destinationAddressId={destinationAddressId}
                  />
                )}
                {isLoading && <Spinner />}
              </Box>
            </Box>
          </Card>
        </>
      )}
    </>
  );
};

const mapStateToProps = state => {
  const { addressTypes, countries, provinces } = state.enumerations.allEnums;
  return {
    addressTypesEnum: addressTypes,
    countriesEnum: countries,
    provincesEnum: provinces
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    postAddress,
    updateAddress,
    deleteAddress,
    getAddress,
    showToast,
    getAuthorizationSummaryAddress
  })
)(AddressManagementCard);
